(() => {
  const PREVIEW_PARAM = 'preview_theme_id';
  const storefrontRoot = () => window.Shopify?.routes?.root || '/';
  const localizedPath = (path) => {
    const value = String(path || '');
    return `${storefrontRoot()}${value.startsWith('/') ? value.slice(1) : value}`;
  };
  const EDITIONS = [
    { handle: 'signature-edition-kochkeramik', label: 'Signature', color: '#B7663F' },
    { handle: 'coffee-edition-kochkeramik', label: 'Coffee', color: '#49332C' },
    { handle: 'cream-edition-kochkeramik', label: 'Cream', color: '#EEE6D8' }
  ];

  const withPreview = (path) => {
    const url = new URL(path, window.location.origin);
    const previewId = new URLSearchParams(window.location.search).get(PREVIEW_PARAM);
    if (previewId) url.searchParams.set(PREVIEW_PARAM, previewId);
    return `${url.pathname}${url.search}`;
  };

  const currentEdition = () => {
    const match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    if (!match) return null;
    const handle = decodeURIComponent(match[1]);
    return EDITIONS.find((edition) => edition.handle === handle) || null;
  };

  const editionLinks = (activeHandle, className) => EDITIONS.map((edition) => `<a class="${className}" href="${withPreview(localizedPath(`collections/${edition.handle}`))}"${edition.handle === activeHandle ? ' aria-current="page"' : ''}><span class="mse-edition-dot" style="--mse-edition-color:${edition.color}" aria-hidden="true"></span><span>${edition.label}</span></a>`).join('');

  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  })[character]);

  const localizedEditionFallback = () => {
    const locale = String(document.documentElement.lang || 'de').toLowerCase().split('-')[0];
    const copy = {
      de: { eyebrow:'Deine Farbwelt', title:'Edition wechseln', switcherAria:'Farbwelt wechseln', facetAria:'Farbwelt wählen' },
      en: { eyebrow:'Your colour world', title:'Switch edition', switcherAria:'Switch colour world', facetAria:'Choose colour world' },
      fr: { eyebrow:'Votre univers de couleurs', title:'Changer d’édition', switcherAria:'Changer d’univers de couleurs', facetAria:'Choisir un univers de couleurs' },
      nl: { eyebrow:'Jouw kleurwereld', title:'Van editie wisselen', switcherAria:'Kleurwereld wisselen', facetAria:'Kleurwereld kiezen' },
      it: { eyebrow:'La tua palette', title:'Cambia edizione', switcherAria:'Cambia palette', facetAria:'Scegli palette' },
      lb: { eyebrow:'Deng Faarfwelt', title:'Editioun wiesselen', switcherAria:'Faarfwelt wiesselen', facetAria:'Faarfwelt auswielen' },
      sv: { eyebrow:'Din färgvärld', title:'Byt edition', switcherAria:'Byt färgvärld', facetAria:'Välj färgvärld' }
    };
    return copy[locale] || copy.en;
  };

  const editionUi = () => {
    const config = document.getElementById('myromy-edition-switcher-config');
    const fallback = localizedEditionFallback();
    return {
      eyebrow: config?.dataset.eyebrow || fallback.eyebrow,
      title: config?.dataset.title || fallback.title,
      switcherAria: config?.dataset.switcherAria || fallback.switcherAria,
      facetAria: config?.dataset.facetAria || fallback.facetAria
    };
  };

  const addStyles = () => {
    if (document.getElementById('myromy-review-finishing-styles')) return;
    const style = document.createElement('style');
    style.id = 'myromy-review-finishing-styles';
    style.textContent = `
      .mse-edition-switcher{max-width:var(--container-max-width,1400px);margin:0 auto clamp(28px,3.4vw,46px);padding:0 var(--container-gutter);color:#17231d}
      .mse-edition-switcher__panel{display:grid;grid-template-columns:minmax(155px,.62fr) minmax(0,1.65fr);align-items:center;gap:clamp(18px,3vw,42px);padding:18px 20px;border-top:1px solid rgba(23,35,29,.16);border-bottom:1px solid rgba(23,35,29,.16);background:rgba(255,255,255,.42)}
      .mse-edition-switcher__eyebrow{display:block;margin:0 0 5px;font-size:10px;font-weight:800;letter-spacing:.14em;text-transform:uppercase;opacity:.55}
      .mse-edition-switcher__title{display:block;font-size:15px;font-weight:700;line-height:1.25}
      .mse-edition-switcher__track{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px}
      .mse-edition-switcher__chip{display:flex;align-items:center;gap:10px;min-height:48px;padding:10px 13px;border:1px solid rgba(23,35,29,.18);border-radius:12px;background:rgba(255,255,255,.84);color:#17231d;text-decoration:none;font-size:12px;line-height:1.2;transition:background-color .16s ease,border-color .16s ease,box-shadow .16s ease,transform .16s ease}
      .mse-edition-dot{display:inline-block;flex:0 0 auto;width:18px;height:18px;border-radius:50%;background:var(--mse-edition-color);border:1px solid rgba(23,35,29,.16);box-shadow:inset 0 0 0 1px rgba(255,255,255,.18)}
      .mse-edition-switcher__chip[aria-current=page]{border-color:#002a23;box-shadow:inset 0 0 0 1px #002a23;background:#fff;font-weight:750}
      .mse-edition-switcher__chip[aria-current=page]::after{content:'✓';margin-left:auto;font-size:12px;font-weight:800;color:#002a23}
      .mse-edition-switcher__chip:focus-visible,.mse-edition-facet__option:focus-visible{outline:3px solid rgba(0,42,35,.18);outline-offset:2px}
      @media(hover:hover) and (pointer:fine){.mse-edition-switcher__chip:not([aria-current=page]):hover{background:#fff;border-color:rgba(23,35,29,.38);transform:translateY(-1px)}}
      @media(max-width:749px){.mse-edition-switcher{margin-bottom:26px}.mse-edition-switcher__panel{grid-template-columns:1fr;gap:14px;padding:16px 0;background:transparent}.mse-edition-switcher__track{display:flex;overflow-x:auto;scroll-snap-type:x proximity;scrollbar-width:none;padding:1px 1px 3px}.mse-edition-switcher__track::-webkit-scrollbar{display:none}.mse-edition-switcher__chip{flex:0 0 132px;scroll-snap-align:start}}

      .mse-edition-facet{display:grid;gap:4px;padding:2px 0 3px}
      .mse-edition-facet__option{display:flex;align-items:center;gap:11px;width:100%;min-height:40px;padding:7px 8px;border:1px solid transparent;border-radius:10px;color:inherit;text-decoration:none;font-size:13px;line-height:1.25;opacity:.8;transition:background-color .15s ease,border-color .15s ease,opacity .15s ease}
      .mse-edition-facet__option .mse-edition-dot{width:22px;height:22px}
      .mse-edition-facet__option[aria-current=page]{background:rgba(0,42,35,.045);border-color:rgba(0,42,35,.16);opacity:1;font-weight:750}
      .mse-edition-facet__option[aria-current=page]::after{content:'✓';margin-left:auto;font-size:12px;font-weight:800;color:#002a23}
      @media(hover:hover) and (pointer:fine){.mse-edition-facet__option:not([aria-current=page]):hover{background:rgba(0,42,35,.035);opacity:1}}

      .mse-ratgeber-review .mse-review-rhythm-title{font-size:clamp(30px,4vw,46px)!important;line-height:1.08!important;letter-spacing:-.025em!important;margin-top:0!important}
      .mse-ratgeber-review .mse-review-rhythm-eyebrow{display:block!important;margin-bottom:12px!important;font-size:11px!important;font-weight:800!important;letter-spacing:.13em!important;text-transform:uppercase!important}
      .mse-ratgeber-review .myromy-knowledge-map{padding-block:clamp(52px,7vw,88px)!important}
      .mse-ratgeber-review .myromy-knowledge-map__head{max-width:780px!important;margin-bottom:28px!important}
      .mse-ratgeber-review .myromy-knowledge-map__eyebrow{margin-bottom:12px!important;font-size:11px!important;letter-spacing:.13em!important}
      .mse-ratgeber-review .myromy-knowledge-map h2{font-size:clamp(30px,4vw,46px)!important;line-height:1.08!important;letter-spacing:-.025em!important}
      @media(prefers-reduced-motion:reduce){.mse-edition-switcher__chip{transition:none}.mse-edition-facet__option{transition:none}}
    `;
    document.head.appendChild(style);
  };


  const mountEditionSwitcher = () => {
    const edition = currentEdition();
    if (!edition) return;
    if (document.querySelector('[data-myromy-edition-switcher]')) return;
    const section = document.querySelector('.shopify-section--main-collection') || [...document.querySelectorAll('.shopify-section')].find((el) => el.querySelector('facets-form, .collection'));
    if (!section) return;

    const nav = document.createElement('nav');
    nav.className = 'mse-edition-switcher';
    nav.dataset.myromyEditionSwitcher = 'true';
    const ui = editionUi();
    nav.setAttribute('aria-label', ui.switcherAria);
    nav.innerHTML = `<div class="mse-edition-switcher__panel"><div class="mse-edition-switcher__head"><span class="mse-edition-switcher__eyebrow">${escapeHtml(ui.eyebrow)}</span><span class="mse-edition-switcher__title">${escapeHtml(ui.title)}</span></div><div class="mse-edition-switcher__track">${editionLinks(edition.handle, 'mse-edition-switcher__chip')}</div></div>`;

    const container = section.querySelector('.container');
    if (container) container.insertBefore(nav, container.firstElementChild);
    else section.insertBefore(nav, section.firstElementChild);

    const active = nav.querySelector('[aria-current="page"]');
    const track = nav.querySelector('.mse-edition-switcher__track');
    if (active && track && window.matchMedia('(max-width: 749px)').matches) requestAnimationFrame(() => { track.scrollLeft = Math.max(0, active.offsetLeft - ((track.clientWidth - active.clientWidth) / 2)); });
  };

  const mountEditionFacetPicker = () => {
    const edition = currentEdition();
    if (!edition) return;
    document.querySelectorAll('.facets-vertical details.accordion').forEach((details) => {
      const content = details.querySelector(':scope > .accordion__content');
      if (!content) return;

      const nativeColorList = content.querySelector('.color-list');
      if (!nativeColorList) return;
      const filterText = Array.from(nativeColorList.querySelectorAll('input[type="checkbox"], label'))
        .map((element) => `${element.textContent || ''} ${element.value || ''}`)
        .join(' ')
        .toLowerCase();
      const editionMatches = EDITIONS.filter((editionItem) => filterText.includes(editionItem.handle.split('-')[0])).length;
      if (editionMatches < 2) return;
      nativeColorList.hidden = true;

      let picker = content.querySelector('[data-myromy-edition-facet]');
      if (!picker) {
        picker = document.createElement('nav');
        picker.className = 'mse-edition-facet';
        picker.dataset.myromyEditionFacet = 'true';
        picker.setAttribute('aria-label', editionUi().facetAria);
        picker.innerHTML = editionLinks(edition.handle, 'mse-edition-facet__option');
        content.insertBefore(picker, content.firstChild);
        details.open = true;
        details.setAttribute('aria-expanded', 'true');
      }
    });
  };

  const markRatgeberRhythm = () => {
    if (window.location.pathname.replace(/\/$/, '') !== localizedPath('pages/ratgeber').replace(/\/$/, '')) return;
    document.body.classList.add('mse-ratgeber-review');
    const selectors = [
      '.mse-pv2__related header h2',
      '.mse-pv2__faq header h2',
      '.myromy-knowledge-map__head h2'
    ];
    document.querySelectorAll(selectors.join(',')).forEach((heading) => {
      heading.classList.add('mse-review-rhythm-title');
      const parent = heading.parentElement;
      const previous = heading.previousElementSibling;
      if (previous && previous.textContent) previous.classList.add('mse-review-rhythm-eyebrow');
      if (parent) parent.dataset.myromyReviewRhythm = 'true';
    });
  };


  const run = () => {
    addStyles();
    mountEditionSwitcher();
    mountEditionFacetPicker();
    markRatgeberRhythm();
  };

  const startEditionObserver = () => {
    if (window.__myromyEditionReviewObserver || !currentEdition()) return;
    let raf = 0;
    const observer = new MutationObserver((mutations) => {
      if (!mutations.some((mutation) => mutation.addedNodes.length || mutation.removedNodes.length)) return;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        raf = 0;
        mountEditionSwitcher();
        mountEditionFacetPicker();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.__myromyEditionReviewObserver = observer;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { run(); startEditionObserver(); }, { once: true });
  else { run(); startEditionObserver(); }
  window.setTimeout(run, 180);
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:select', run);
})();
